import { QuotationProps } from '../types';
import {QuotationWithDraftsSchema} from "../types";
import {useQuotations} from "../hooks/useQuotations";
import {useEffect, useState} from "react";
import {QuotationDetail} from "./quotation-detail";
import Spinner from "@ui-components/Spinner";
import NotFound from "../../../ui-components/pages/NotFound";


export const Quotation = ({id}: QuotationProps) => {

  // hooks
  const {fetchOne} = useQuotations();

  // state
  const [data, setData]
    = useState<QuotationWithDraftsSchema>();
  const [showNotFound, setShowNotFound] = useState<boolean>(false);

  useEffect(() => {
    // On page load, fetch the target quotation
    const fetchData = async () => {
      try {
        const data = await fetchOne(id);
        setData(data);
      } catch (error: any) {
        if (error.response.status === 404){
          setShowNotFound(true)
        }
      }
    }
    fetchData();
  }, [id]);  // eslint-disable-line react-hooks/exhaustive-deps

  return (
    showNotFound ? <NotFound/> :
      data?<QuotationDetail
        quotation={data}
        setQuotation={setData}
      />: <Spinner classes={undefined} styleType={undefined} />
  )
}